module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_all_wod_trainings_title')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.showDefinitionAdd
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_partner')))])]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input search-input-wide",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_trainings_definition'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed table-bottom-space"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_td_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_td_short_desc")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_td_type")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_td_category")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_edit")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_delete")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.trainings), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_td_name')
      }
    }, [_vm._v(_vm._s(_vm.checkNullEmpty(_vm.getName(item))))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_td_short_desc')
      }
    }, [_vm._v(_vm._s(_vm.checkNullEmpty(_vm.getShortDesc(item))))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_td_type')
      }
    }, [_vm._v(_vm._s(_vm.checkNullEmpty(item.trainingType)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_td_category')
      }
    }, [_vm._v(_vm._s(_vm.checkNullEmpty(item.category)))]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editDefinitionData(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_edit")) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteTrainingDefinition(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_delete")) + "\n              ")])])])
  }), 0)]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 pagination-bg-deep"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])]), _vm._v(" "), _c('add-training-definition-wod', {
    attrs: {
      "show": _vm.showAddDefinition,
      "date": _vm.addDefinitionDate,
      "type": 'WOD',
      "data": _vm.definitionDataToEdit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05f84080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wod/AllWodTrainings.vue
// module id = 718
// module chunks = 0